import React from 'react';
import { getCookie } from '../../utility/cookies';

export default function WebDashLanding({ }) {

  const [sessionId, setSessionId] = React.useState(null);

  React.useEffect(() => {
    const loadSessionId = async () => {
      const storedSessionId = await getCookie('wdsid');
      if (storedSessionId) {
        setSessionId(storedSessionId);
      }
    };
    
    loadSessionId();
  }, []);

  React.useEffect(() => {
    if (sessionId) {
      window.location.replace(`${window.location.href}/${sessionId}`);
    } else {
      window.location.replace(`${window.location.href}/new`);
    }
  }, [sessionId]);

  return false;

}